import { defineMessages } from 'react-intl';

const messages = defineMessages({
  age: {
    id: 'onboardingPages.clientOnboarding.aboutStep.age',
    defaultMessage: 'Age',
  },
  ageHelper: {
    id: 'onboardingPages.clientOnboarding.aboutStep.ageHelper',
    defaultMessage:
      '* You have to be at least 16 years old to use this platform.',
  },
  description: {
    id: 'onboardingPages.clientOnboarding.aboutStep.description',
    defaultMessage: 'This will help track your progress.',
  },
  email: {
    id: 'onboardingPages.clientOnboarding.aboutStep.email',
    defaultMessage: 'Email',
  },
  emailHelper: {
    id: 'onboardingPages.clientOnboarding.aboutStep.emailHelper',
    defaultMessage: '* Email you are currently logged with.',
  },
  height: {
    id: 'onboardingPages.clientOnboarding.aboutStep.height',
    defaultMessage: 'Height (cm)',
  },
  name: {
    id: 'onboardingPages.clientOnboarding.aboutStep.name',
    defaultMessage: 'Name',
  },
  phone: {
    id: 'onboardingPages.clientOnboarding.aboutStep.phone',
    defaultMessage: 'Phone number',
  },
  title: {
    id: 'onboardingPages.clientOnboarding.aboutStep.title',
    defaultMessage: 'Tell us about yourself',
  },
  weight: {
    id: 'onboardingPages.clientOnboarding.aboutStep.weight',
    defaultMessage: 'Weight (kg)',
  },
});

export default messages;
